import React, {useState} from 'react'
import {
  Button,
  Checkbox,
  Box,
  Grid,
  Paper,
  TextField,
  Typography} from "@mui/material";
import BuyWithAutoComplete from "../admin/manual-buy/BuyWithAutoComplete";
import { useForm } from "react-hook-form";

const PlaceSuperOrder = ({user}) => {
    const { register, handleSubmit, formState: { errors } } = useForm()
    const [selectedSymbol, setSelectedSymbol] = useState({});

    return (
            <Grid item container xs={12} md={12} spacing={2}>
              <Grid item xs={12} md={6} lg={12}>
              <Typography variant="h6" gutterBottom>Place Super Order</Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={12}>
                    <Grid item xs={12} md={4}>
                                            <Box component="div" display="flex" flexDirection="column" justifyContent="space-between" m={2}>
                                                <Box m={2}>
                                                    <BuyWithAutoComplete user={user} errors={errors} register={register} setSelectedSymbol={setSelectedSymbol} />
                                                </Box>
                                                </Box>
                                                </Grid>
                    </Grid>
            </Grid>
    )
}

export default PlaceSuperOrder